import { useQuery } from '@tanstack/react-query';

import { getPromotions } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../queries.utils';
import { promotionsKeyFn } from './rewards.keys';

export function useGetPromotionsQuery(
  filters?: Rewards.PromotionFilters,
  options?: UseQueryOptions<Rewards.PromotionSearchResult>
): UseQueryResult<Rewards.PromotionSearchResult> {
  return useQuery(promotionsKeyFn(filters), async () => getPromotions(filters), {
    ...options,
    enabled: options?.enabled ?? true,
    staleTime: options?.staleTime,
  });
}
